module.exports = __webpack_public_path__ + "img/7.5f927dd1.jpg";